if (!customElements.get("media-gallery")) {
  class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        mediaButtons: this.querySelectorAll('[id^="MediaButtons"] [data-target]'),
        prevButton: this.querySelectorAll('button.gallery-button[name="previous-slide"]'),
        nextButton: this.querySelectorAll('button.gallery-button[name="next-slide"]'),
        slider: this.querySelector('[id^="Slider-Thumbnails"]'),
        mediaContainer: this.querySelector(".media-container"),
        dimensionsButton: this.querySelector(".dimensions-button"),
        threeDimensionButton: this.querySelector(".three-dimensions"),
      };
      this.mql = window.matchMedia("(min-width: 750px)");

      this.slideScrollPosition = 0;
      if (!this.elements.thumbnails || !this.elements.liveRegion) return;

      let currentIndex = 0;
      const slides = Array.from(this.elements.viewer.querySelectorAll(".product-media-item"));
      const totalSlides = slides.length;
      document.querySelector(".slider-counter").innerText = `${currentIndex + 1} / ${totalSlides}`;

      // Set initial thumbnail max-height
      this.setThumbnailMaxHeight();

      window.addEventListener("resize", this.setThumbnailMaxHeight.bind(this));

      // Add media buttons event listener
      this.elements.mediaButtons.forEach((mediaToSwitch) => {
        mediaToSwitch.addEventListener("click", this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });

      this.elements.viewer.addEventListener("slideChanged", debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll("[data-target]").forEach((mediaToSwitch) => {
        mediaToSwitch
          .querySelector("button")
          .addEventListener("click", this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });

      if (this.elements.viewer.querySelectorAll(".product-media-item").length > 2) {
        this.elements.prevButton.forEach((button) => {
          button.addEventListener("click", this.onButtonClick.bind(this));
        });

        this.elements.nextButton.forEach((button) => {
          button.style.display = "flex";
          button.addEventListener("click", this.onButtonClick.bind(this));
        });
      }

      this.elements.viewer.querySelector('button[name="previous-slide"]').style.display = "none";

      this.elements.viewer.querySelector("ul").addEventListener("scroll", this.onThumbnailScroll.bind(this));

      this.elements.dimensionsButton?.addEventListener("click", () => {
        this.onDimensionsButtonClick(() => {
          return this.elements.thumbnails.querySelector('button[aria-current="true"]').closest("li");
        });
      });

      this.elements.threeDimensionButton?.addEventListener("click", () => {
        this.onDimensionsButtonClick(() => {
          return this.elements.thumbnails.querySelector(".model-thumbnail");
        });
      });

      this.scrollToTop();
      if (this.dataset.desktopLayout.includes("thumbnail") && this.mql.matches) this.removeListSemantic();

      this.updateButtonStates(this.elements.thumbnails.querySelector("li:first-child"));

      this.elements.thumbnails.querySelector("li:first-child").classList.add("thumbnail-active");

      if (totalSlides === 1) {
        this.elements.viewer.querySelector('button[name="previous-slide"]').style.display = "none";
      }
    }

    onDimensionsButtonClick(getActiveThumbnail) {
      const oldActive = document.querySelector(".thumbnail-active");
      if (oldActive) {
        oldActive.classList.remove("thumbnail-active");
      }

      const activeThumbnail = getActiveThumbnail();
      const thumbnailOffsetTop = activeThumbnail.offsetTop;
      activeThumbnail.classList.add("thumbnail-active");
      this.setSlidePosition(thumbnailOffsetTop);
      this.updateButtonStates(activeThumbnail);
    }

    updateSlideCounter() {
      const thumbnails = Array.from(this.elements.viewer.querySelectorAll(".product-media-item"));
      const activeThumbnail = this.elements.viewer.querySelector(".product-media-item.is-active");

      if (activeThumbnail) {
        const activeIndex = thumbnails.indexOf(activeThumbnail) + 1;
        const totalSlides = thumbnails.length;

        const counterElement = document.querySelector(".slider-counter");
        if (counterElement) {
          counterElement.innerText = `${activeIndex} / ${totalSlides}`;
        }

        if (activeIndex === 1) {
          this.elements.viewer.querySelector('button[name="previous-slide"]').style.display = "none";
        } else {
          this.elements.viewer.querySelector('button[name="previous-slide"]').style.display = "block";
        }
      }
    }

    onThumbnailScroll() {
      const thumbnails = Array.from(this.elements.viewer.querySelectorAll(".product-media-item"));
      let closestThumbnail = null;
      let minDistance = Infinity;

      thumbnails.forEach((thumbnail) => {
        const rect = thumbnail.getBoundingClientRect();
        const containerRect = this.elements.thumbnails.getBoundingClientRect();

        const distance = Math.abs(rect.left - containerRect.left);

        if (distance < minDistance) {
          minDistance = distance;
          closestThumbnail = thumbnail;
        }
      });

      if (closestThumbnail) {
        thumbnails.forEach((thumb) => thumb.classList.remove("is-active"));
        closestThumbnail.classList.add("is-active");
        this.updateSlideCounter();
        this.playActiveMedia(closestThumbnail);

        if (closestThumbnail.querySelector("product-model")) {
          closestThumbnail.querySelector(".product-media").style.display = "none";
        } else {
          closestThumbnail.querySelector(".product-media").style.display = "block";
        }
      }
    }

    setThumbnailMaxHeight(event) {
      let galleryViewerHeight = this.elements.viewer.offsetHeight * 0.6;

      if (event) {
        galleryViewerHeight = this.elements.viewer.offsetHeight - 60;
      }

      const thumbnailsList = this.elements.thumbnails.querySelector(".thumbnail-list");

      if (thumbnailsList) {
        thumbnailsList.style.maxHeight = `${galleryViewerHeight}px`;

        const thumbnailHeight = galleryViewerHeight / 6;

        this.elements.thumbnails.querySelectorAll(".thumbnail-list-item").forEach((element) => {
          element.style.height = `${thumbnailHeight}px`;
        });
      }
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(
        `[data-target="${event.detail.currentElement?.dataset.mediaId}"]`
      );
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia =
        this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
        this.elements.viewer.querySelector("[data-media-id]");
      if (!activeMedia) {
        return;
      }
      this.elements.viewer.querySelectorAll("[data-media-id]").forEach((element) => {
        element.classList.remove("is-active");
      });

      if (activeMedia.querySelector("product-model")) {
        activeMedia.querySelector(".product-media").style.display = "none";
      } else {
        activeMedia.querySelector(".product-media").style.display = "block";
      }

      activeMedia?.classList?.add("is-active");
      if (prepend) {
        activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          activeThumbnail.parentElement.firstChild !== activeThumbnail &&
            activeThumbnail.parentElement.prepend(activeThumbnail);
        }
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (!this.mql.matches || this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({
            left: activeMedia.offsetLeft,
          });
        }
        const activeMediaRect = activeMedia.getBoundingClientRect();
        // Don't scroll if the image is already in view
        if (activeMediaRect.top > -0.5) return;
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);

      this.updateButtonStates(activeThumbnail);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll("button").forEach((element) => element.removeAttribute("aria-current"));

      const oldActive = document.querySelector(".thumbnail-active");
      if (oldActive) {
        oldActive.classList.remove("thumbnail-active");
      }

      thumbnail.classList.add("thumbnail-active");

      thumbnail.querySelector("button").setAttribute("aria-current", true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({
        left: thumbnail.offsetLeft,
      });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector(".product__modal-opener--image img");
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute("aria-hidden", false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace("[index]", position);
        setTimeout(() => {
          this.elements.liveRegion.setAttribute("aria-hidden", true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      pauseAllMedia();
      const deferredMedia = activeItem.querySelector(".deferred-media");
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    scrollToTop() {
      document.querySelectorAll(".thumbnail-list-item").forEach((item) => {
        item.addEventListener("click", function () {
          window.scrollTo({ top: 0, behavior: "smooth" });
        });
      });
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector("sticky-header");
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute("role", "presentation");
      this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute("role", "presentation"));
    }

    onButtonClick(event) {
      const isMobile = window.innerWidth <= 1050;

      if (isMobile) {
        const currentActiveThumbnail = this.elements.viewer.querySelector(".product-media-item.is-active");

        const isNext = event.currentTarget.name === "next-slide";
        const newActiveThumbnail = isNext
          ? currentActiveThumbnail.nextElementSibling
          : currentActiveThumbnail.previousElementSibling;

        if (newActiveThumbnail && newActiveThumbnail.classList.contains("product-media-item")) {
          this.elements.viewer
            .querySelectorAll(".product-media-item.is-active")
            .forEach((el) => el.classList.remove("is-active"));
          newActiveThumbnail.classList.add("is-active");

          this.updateSlideCounter();

          const mediaId = newActiveThumbnail.dataset.mediaId;
          this.setActiveMedia(mediaId, false);

          this.elements.viewer.scrollTo({
            left: newActiveThumbnail.offsetLeft,
            behavior: "smooth",
          });

          this.updateButtonStates(newActiveThumbnail);
        }
      } else {
        const currentActiveThumbnail = this.elements.thumbnails.querySelector('button[aria-current="true"]');

        const isNext = event.currentTarget.name === "next-slide";
        const newActiveThumbnail = isNext
          ? currentActiveThumbnail.closest("li").nextElementSibling
          : currentActiveThumbnail.closest("li").previousElementSibling;

        if (newActiveThumbnail) {
          const mediaId = newActiveThumbnail.dataset.target;

          this.setActiveMedia(mediaId, false);

          const thumbnailOffsetTop = newActiveThumbnail.offsetTop;
          this.setSlidePosition(thumbnailOffsetTop);
          this.updateButtonStates(newActiveThumbnail);
        }
      }
    }

    updateButtonStates(newActiveThumbnail) {
      const nextButton = this.elements.thumbnails.querySelector('button[name="next-slide"]');
      const prevButton = this.elements.thumbnails.querySelector('button[name="previous-slide"]');

      const firstThumbnail = this.elements.thumbnails.querySelector("li:first-child");
      const lastThumbnail = this.elements.thumbnails.querySelector("li:last-child");

      prevButton.disabled = newActiveThumbnail === firstThumbnail;
      nextButton.disabled = newActiveThumbnail === lastThumbnail;
    }

    setSlidePosition(position) {
      if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);

      const maxScrollPosition =
        this.elements.thumbnails.slider.scrollHeight - this.elements.thumbnails.slider.clientHeight;
      const boundedPosition = Math.max(0, Math.min(position, maxScrollPosition));

      this.setPositionTimeout = setTimeout(() => {
        this.elements.thumbnails.slider.scrollTo({
          top: boundedPosition,
          behavior: "smooth",
        });
      }, 100);
    }
  }

  customElements.define("media-gallery", MediaGallery);

  customElements.define(
    "variant-media-gallery",
    class VariantMediaGallery extends MediaGallery {
      connectedCallback() {
        this.bindListeners();
      }

      bindListeners() {
        const variantRadios = document.getElementById(`VariantRadios-${this.dataset.sectionId}`);
        if (variantRadios) {
          variantRadios.addEventListener("variantChange", this.onVariantChange.bind(this));
        }
      }

      /**
       * when variant changes, iterate over slides
       * if the variantId data property contains the current variant ID, then show
       *
       * after, update media count for a11y
       */
      onVariantChange(e) {
        const variantId = e.detail.id;

        if (variantId) {
          const slides = Array.from(this.querySelectorAll(".product-media-item"));

          let mediaCount = 0;

          slides.forEach((slide) => {
            slide.classList.remove("for-variant");
            if (
              typeof slide.dataset.variantIds !== "undefined" &&
              slide.dataset.variantIds !== null &&
              slide.dataset.variantIds.includes(variantId)
            ) {
              slide.classList.add("for-variant");
              mediaCount++;
            }
          });

          setTimeout(() => {
            this.querySelector(".slider-counter-total").textContent = mediaCount;
          });
        }
      }
    }
  );
}
